/*
 * Parcours d'achat de la fiche produit (maquette client 04/08).
 *
 * - Sélecteur à deux volets « Prêt-à-porter » / « Sur-mesure »
 * - Liens de bascule contextuels d'un volet vers l'autre
 * - Message de bascule qui suit la variante sélectionnée
 * - Fenêtre d'information matière (pastilles « i » du volet Sur-mesure)
 *
 * Délégation globale : un seul écouteur, valable pour toutes les instances
 * (fiche produit, produit mis en avant), sans initialisation par section.
 */
(function () {
  if (window.__productParcoursInit) return;
  window.__productParcoursInit = true;

  function setParcours(root, target) {
    if (!root) return;
    root.querySelectorAll('[data-parcours-tab]').forEach(function (tab) {
      var active = tab.getAttribute('data-parcours-tab') === target;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    root.querySelectorAll('[data-parcours-panel]').forEach(function (panel) {
      if (panel.getAttribute('data-parcours-panel') === target) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-parcours-tab]');
    if (tab) {
      setParcours(tab.closest('[data-product-parcours]'), tab.getAttribute('data-parcours-tab'));
      return;
    }

    var goto = event.target.closest('[data-parcours-goto]');
    if (goto) {
      var root = goto.closest('[data-product-parcours]');
      var target = goto.getAttribute('data-parcours-goto');
      setParcours(root, target);
      if (root && typeof root.scrollIntoView === 'function') {
        root.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      return;
    }

    var trigger = event.target.closest('[data-material-info]');
    if (trigger) {
      openMaterialInfo(trigger.getAttribute('data-material-info'));
      return;
    }

    if (event.target.closest('[data-material-info-close]')) {
      closeMaterialInfo();
    }
  });

  /* ── Fenêtre d'information matière ── */
  var lastFocused = null;

  function getModal() {
    return document.querySelector('[data-material-info-modal]');
  }

  function openMaterialInfo(material) {
    var modal = getModal();
    if (!modal) return;
    // La colonne info est un conteneur sticky (transform) : un position:fixed y reste
    // prisonnier. On sort la fenêtre au premier ouvrage pour qu'elle couvre l'écran.
    if (modal.parentElement !== document.body) document.body.appendChild(modal);
    lastFocused = document.activeElement;
    modal.querySelectorAll('[data-material-info-panel]').forEach(function (panel) {
      if (panel.getAttribute('data-material-info-panel') === material) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
    modal.removeAttribute('hidden');
    document.body.classList.add('material-info-open');
    var dialog = modal.querySelector('.material-info__dialog');
    if (dialog) dialog.focus();
  }

  function closeMaterialInfo() {
    var modal = getModal();
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.body.classList.remove('material-info-open');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var modal = getModal();
    if (modal && !modal.hasAttribute('hidden')) closeMaterialInfo();
  });

  /* ── Message de bascule + bouton panier alignés sur la variante sélectionnée ── */
  document.addEventListener('variant:changed', function (event) {
    var variant = event && event.detail && event.detail.variant;
    if (!variant || !variant.id) return;
    var id = String(variant.id);
    document.querySelectorAll('[data-parcours-switch]').forEach(function (container) {
      container.querySelectorAll('[data-parcours-switch-variant]').forEach(function (line) {
        if (line.getAttribute('data-parcours-switch-variant') === id) {
          line.removeAttribute('hidden');
        } else {
          line.setAttribute('hidden', '');
        }
      });
    });

    // Le bouton panier du volet Prêt-à-porter est propre au thème Drucker : il n'est
    // pas repris par la mise à jour de variante du thème, on le synchronise ici.
    document.querySelectorAll('.product-buttons-row__atc').forEach(function (button) {
      var available = variant.available === true;
      button.disabled = !available;
      var label = button.querySelector('.product-buttons-row__atc-label');
      if (!label) return;
      var text = available ? button.dataset.atcLabelAvailable : button.dataset.atcLabelSoldout;
      if (text) label.textContent = text;
    });
  });
})();
